export function toDate(input: any): Date | null {
  if (!input) return null;
  try {
    // Firestore Timestamp
    if (typeof input === 'object') {
      if (typeof (input as any).toDate === 'function') {
        const d = (input as any).toDate();
        return isNaN(d?.getTime?.()) ? null : d;
      }
      if (typeof (input as any).seconds === 'number') {
        const ms = ((input as any).seconds || 0) * 1000 + (((input as any).nanoseconds || 0) / 1e6);
        const d = new Date(ms);
        return isNaN(d.getTime()) ? null : d;
      }
    }
    // Numeric epoch
    if (typeof input === 'number') {
      const ms = input < 1e11 ? input * 1000 : input; // seconds vs ms
      const d = new Date(ms);
      return isNaN(d.getTime()) ? null : d;
    }
    // String
    if (typeof input === 'string') {
      const trimmed = input.trim();
      if (!trimmed) return null;
      // numeric string
      const asNum = Number(trimmed);
      if (isFinite(asNum) && trimmed === String(asNum)) {
        const ms = asNum < 1e11 ? asNum * 1000 : asNum;
        const d = new Date(ms);
        return isNaN(d.getTime()) ? null : d;
      }
      const d = new Date(trimmed);
      return isNaN(d.getTime()) ? null : d;
    }
    // Date instance
    if (input instanceof Date) {
      return isNaN(input.getTime()) ? null : input;
    }
    return null;
  } catch {
    return null;
  }
}

export function formatDate(input: any, options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' }): string {
  const d = toDate(input);
  if (!d) return '';
  return new Intl.DateTimeFormat(undefined, options).format(d);
}

export function formatDateTime(input: any, options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }): string {
  const d = toDate(input);
  if (!d) return '';
  return new Intl.DateTimeFormat(undefined, options).format(d);
}